import React, { useEffect } from 'react';
import { useDispatch } from '../GlobalState';
import useDetectPercentageViewport from '../../hooks/useDetectPercentageViewport';

interface NavInViewProps {
  id: string;
  children: React.ReactNode;
  pageRoot?: string;
  isdefault: boolean;
}

const NavInView: React.FC<NavInViewProps> = ({
  children,
  id,
  pageRoot,
  isdefault,
}) => {
  const dispatch = useDispatch();
  const isCurrent = useDetectPercentageViewport(id);

  useEffect(() => {
    if (isCurrent || isdefault) {
      dispatch({
        type: 'PAGE_SET_CURRENT',
        currentPage: pageRoot ? `${pageRoot}/#${id}` : `/#${id}`,
      });
    }
  }, [isCurrent]);

  return <div id={id}>{children}</div>;
};

export default NavInView;
